module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Missed-call-25fa92398eb6c057afb2ba317943ea7a.svg";